import {
  AHNumberInputRef,
  AHTeamIconCircle,
  AHText,
  Box,
  ColorType,
  Space,
  TouchableBox,
} from "arkh";
import React, { useMemo, useRef } from "react";
import { StyleProp, View, ViewStyle } from "react-native";

import {
  NumberGoalValueIcon,
  NumberGoalValueInput,
} from "../../../components/mobile/NumberGoalValueInput";

type Team = {
  id: string;
  icon: string | null;
  color: string | null;
  name: string;
};

export function KPISectionListItem(
  props: React.PropsWithChildren<{
    team?: Team;

    name?: string;
    onPress?: () => void;
    borderColor?: ColorType;
    borderWidth?: number;
    style?: StyleProp<ViewStyle>;
  }>
) {
  const name = useMemo(
    () => props.name ?? props.team?.name ?? "",
    [props.name, props.team?.name]
  );

  return (
    <TouchableBox
      onPress={props.onPress}
      space="medium"
      style={[
        {
          flex: 1,
          flexDirection: "row",
          alignItems: "center",
        },
        props.style,
      ]}
    >
      {props.team ? (
        <AHTeamIconCircle
          color={props.team.color}
          type={props.team.icon as any}
          size="smallMedium"
        />
      ) : null}
      <AHText
        type="list-item-title"
        spaceLeft={props.team ? "small" : "none"}
        style={{ flex: 1 }}
      >
        {name}
      </AHText>
      {props.children}
    </TouchableBox>
  );
}

export function KPISectionGoalListItem(props: {
  team?: Team;
  name?: string;
  goalValue: number;
  setGoalValue?: (value: number) => void;
  onFocus?: () => void;
  goalDirection: "greater" | "less";
  spaceHorizontal?: Space;
  maxWidth?: number;
  style?: StyleProp<ViewStyle>;
}) {
  const ref = useRef<AHNumberInputRef>(null);
  return (
    <KPISectionListItem
      style={props.style}
      team={props.team}
      name={props.name}
      onPress={() => {
        ref.current?.focus();

        props.onFocus?.();
      }}
    >
      <View pointerEvents="none">
        {props.setGoalValue ? (
          <NumberGoalValueInput
            ref={ref}
            goal={props.goalDirection === "greater" ? "min" : "max"}
            value={props.goalValue}
            setValue={props.setGoalValue}
            size="small"
          />
        ) : (
          <Box>
            <NumberGoalValueIcon
              goal={props.goalDirection === "greater" ? "min" : "max"}
              unit="CUSTOM"
              value={props.goalValue}
            />
          </Box>
        )}
      </View>
    </KPISectionListItem>
  );
}
